import React from 'react';
import { BrandSymbolWithText } from '../../../../../patterns/00-atoms/brand/brand-symbol-with-text.tsx';
import { Icon } from '../../../../../patterns/00-atoms/icon/icon.tsx';
import { useIsMobile } from '../../../../../utils/hooks/useIsMobile.ts';
import { Button, TextIconButton } from '../../../../../patterns/00-atoms/button/button.tsx';
import { UBTracking } from '../../../../../components/tracking/ubtracking.ts';

export type HeaderProps = {
  showSearch: boolean;
  setShowSearch: (showSearch: boolean) => void;
  showSearchIcon?: boolean;
};

export const Header: React.FunctionComponent<HeaderProps> = props => {
  const { showSearch, setShowSearch } = props;
  const showSearchIcon = props.showSearchIcon ?? true;
  const { isMobile, isSsr } = useIsMobile();
  const toggleSearch = () => setShowSearch(!showSearch);

  return (
    <>
      <div className="bg-sk-red-500 from-sk-red-500 to-sk-red-900 flex justify-center bg-linear-to-r">
        <div className="w-full max-w-[940px] p-2 max-md:grid max-md:grid-cols-[1fr_3fr_1fr] md:flex md:items-center md:justify-center">
          <div className="md:hidden" />
          <a
            href="https://www.speisekarte.de/"
            className="mr-auto block max-md:mr-auto max-md:ml-auto"
            onClick={() => UBTracking.trackEvent.click('header_bar', 'LOGO')}
          >
            <BrandSymbolWithText className="h-8" />
          </a>
          <div className="flex items-center justify-end gap-4">
            {!isSsr &&
              (isMobile ? (
                <a
                  href="https://www.speisekarte.de/anmelden"
                  className="text-sk-grey-0 flex items-center"
                  onClick={() => UBTracking.trackEvent.click('header_bar', 'LOGIN_ICON')}
                >
                  <Icon name="profile" className="text-2xl" />
                </a>
              ) : (
                <Button
                  variant="primary-contrast"
                  href="https://www.speisekarte.de/anmelden"
                  onClick={() => UBTracking.trackEvent.click('header_bar', 'LOGIN_BUTTON')}
                >
                  Login
                </Button>
              ))}

            {showSearchIcon && (
              <TextIconButton
                iconName="search"
                className="text-sk-grey-0!"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                  toggleSearch();
                  UBTracking.trackEvent.click('header_bar', 'SEARCH_ICON');
                }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
